// extracted by mini-css-extract-plugin
export default {"cards__list":"CardsList_cards__list__dDckn"};